import { memo } from 'react'
// Components
import { Shelf } from '@tracklib/kit'
import EntityBlock from 'components/staticpages/blocks/entityblock'

type VideosBlockProps = {
  value: {
    heading: string
    videos: [
      {
        video_url: string
        image: number
        description: string
        title: string
      },
    ]
  }
}

const VideosBlock = ({ value: { heading, videos } }: VideosBlockProps): JSX.Element => (
  <Shelf heading={heading} extraPad>
    {videos.map((video, i) => {
      const item = {
        entity: [{ type: 'video', value: video.video_url }],
        image: video.image,
        description: video.description,
        title: video.title,
      }
      return (
        <Shelf.Item key={String(i)}>
          <EntityBlock item={item} key={String(i)} size={2} />
        </Shelf.Item>
      )
    })}
  </Shelf>
)

export default memo(VideosBlock)
